import { render, staticRenderFns } from "./incomePlanPushBtn.vue?vue&type=template&id=fac96f4c&scoped=true"
import script from "./incomePlanPushBtn.vue?vue&type=script&lang=js"
export * from "./incomePlanPushBtn.vue?vue&type=script&lang=js"
import style0 from "./incomePlanPushBtn.vue?vue&type=style&index=0&id=fac96f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac96f4c",
  null
  
)

export default component.exports